module.exports = __webpack_public_path__ + "img/img-register-scholarship.jpg";